module.exports = __webpack_public_path__ + "img/n26.f14887cc.svg";